import { useContext } from "react";

import { PublicConfigurationContext } from "../../../core/configuration/public/PublicConfigurationContext";
import { useUnauthorizedFetch } from "../../../core/data-access/useUnauthorizedFetch";
import { GenerateAccessKeyRequest } from "./GenerateAccessKeyRequest";
import { GenerateAccessKeyResponse } from "./GenerateAccessKeyResponse";
import { GetDeliveryBucketInfoRequest } from "./GetDeliveryBucketInfoRequest";
import { GetDeliveryBucketInfoResponse } from "./GetDeliveryBucketInfoResponse";

export const usePublicDeliveryApi = () => {
    const { publicDeliveryConfig } = useContext(PublicConfigurationContext);
    const { httpPut, httpGet } = useUnauthorizedFetch();

    const basePublicDeliveryUrl = publicDeliveryConfig.apiUrl;

    const generateAccessKey = (request: GenerateAccessKeyRequest): Promise<GenerateAccessKeyResponse> => {
        return httpPut(`${basePublicDeliveryUrl}/buckets/generate-access-key`, request);
    };

    const getDeliveryBucketInfo = (request: GetDeliveryBucketInfoRequest): Promise<GetDeliveryBucketInfoResponse> => {
        return httpGet(`${basePublicDeliveryUrl}/buckets/info`, request);
    };

    return {
        generateAccessKey,
        getDeliveryBucketInfo
    };
};
